import { call, put, takeLatest } from "redux-saga/effects";

import { ordersApi } from "@src/service/orders";
import { getRequestError } from "@src/utils/getRequestError";
import { setGlobalLoader, setSnackbar } from "../generals/actionCreators";
import { LoadingStatus } from "../generals/types";
import {
  fetchOrderErrorMessageSuccess,
  fetchOrdersErrorMessageInterface,
  fetchOrdersInterface,
  fetchOrdersSuccess,
} from "./actionCreators";
import { OrdersActionTypes } from "./types/actionTypes";

export function* fetchOrdersRequest(action: fetchOrdersInterface): any {
  try {
    yield put(setGlobalLoader(LoadingStatus.LOADING));
    // sorting

    let restaurant_group_id = localStorage.getItem("currRestGroupId");
    let currLocation = localStorage.getItem("currLocation");

    let { params, isActiveOrders, setParams } = action.payload;

    let query = "";

    let page = 1;
    if (params.has("page")) {
      page = Number(params.get("page"));
      params.delete("page");
    }

    if (params.has("group_id") && params.has("restaurant_id")) {
      query += "&" + params.toString();
      const { data } = yield call(ordersApi.getOrders, {
        page,
        query,
        rest_id: params.get("group_id") || "",
        isActiveOrders,
      });
      const paramsObj: any = {
        field: params.get("field"),
        direction: params.get("sort_order"),
      };

      const obj = { ...data, ...paramsObj };
      yield put(fetchOrdersSuccess(obj));

      yield put(setGlobalLoader(LoadingStatus.SUCCESS));
      if (setParams) setParams();
      return;
    }

    if (currLocation !== "all") {
      query += `&restaurant_id=${currLocation}`;
    }
    query += "&" + params.toString();

    const { data } = yield call(ordersApi.getOrders, {
      page,
      query,
      rest_id: restaurant_group_id || "",
      isActiveOrders,
    });
    const paramsObj: any = {
      field: params.get("field"),
      direction: params.get("sort_order"),
    };

    const obj = { ...data, ...paramsObj };
    yield put(fetchOrdersSuccess(obj));

    yield put(setGlobalLoader(LoadingStatus.SUCCESS));
  } catch (e: any) {
    yield put(
      setSnackbar({
        visible: true,
        status: "error",
        message: getRequestError(e),
      })
    );
    yield put(setGlobalLoader(LoadingStatus.ERROR));
  }
}

export function* getOrderErrorMessageRequest(
  action: fetchOrdersErrorMessageInterface
) {
  try {
    const { order_id, restaurant_id } = action.payload;
    const { data } = yield call(
      ordersApi.getOrderErrorMessage,
      restaurant_id,
      order_id
    );

    yield put(fetchOrderErrorMessageSuccess(data?.message));
  } catch (e) {
    yield put(
      setSnackbar({
        visible: true,
        status: "error",
        message: getRequestError(e),
      })
    );
  }
}

export function* ordersSaga() {
  yield takeLatest(OrdersActionTypes.FETCH_ORDERS_SAGA, fetchOrdersRequest);
  yield takeLatest(
    OrdersActionTypes.FETCH_ORDER_ERROR_MESSAGE_SAGA,
    getOrderErrorMessageRequest
  );
}
